import WhatIsASection32, { meta as whatIs } from './WhatIsASection32';
import Section32Checklist, { meta as checklist } from './Section32Checklist';
import EasementsExplained, { meta as easements } from './EasementsExplained';

// Ordered as shown on the guides index page.
export const GUIDES = [
  { ...whatIs, Component: WhatIsASection32 },
  { ...checklist, Component: Section32Checklist },
  { ...easements, Component: EasementsExplained },
];

export function getGuide(slug) {
  return GUIDES.find((g) => g.slug === slug) || null;
}
